import { render, staticRenderFns } from "./StageSubmit.vue?vue&type=template&id=7076587f&"
import script from "./StageSubmit.vue?vue&type=script&lang=js&"
export * from "./StageSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports